import { render, staticRenderFns } from "./SmsBadge.vue?vue&type=template&id=8565c45c&scoped=true"
import script from "./SmsBadge.vue?vue&type=script&lang=js"
export * from "./SmsBadge.vue?vue&type=script&lang=js"
import style0 from "./SmsBadge.vue?vue&type=style&index=0&id=8565c45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8565c45c",
  null
  
)

export default component.exports